import { Controller } from "@hotwired/stimulus"

// Adds and removes the rows of an `accepts_nested_attributes_for` association.
// New rows are cloned from a <template> whose field names use NEW_RECORD as
// the index. Removing a saved row only flags it for destruction, so it can be
// undone before the form is saved.
export default class extends Controller {
  static targets = ["list", "template", "row"]

  add(event) {
    event.preventDefault()

    const index = `${Date.now()}${this.listTarget.children.length}`
    this.listTarget.insertAdjacentHTML("beforeend", this.templateTarget.innerHTML.replace(/NEW_RECORD/g, index))
    this.listTarget.lastElementChild.querySelector("input:not([type=hidden]):not([type=checkbox])")?.focus()
  }

  remove(event) {
    const row = this.rowFor(event)

    if (row.dataset.newRecord === "true") {
      row.remove()
      return
    }

    row.dataset.removed = ""
    this.setDestroy(row, "1")
  }

  restore(event) {
    const row = this.rowFor(event)

    delete row.dataset.removed
    this.setDestroy(row, "0")
  }

  rowFor(event) {
    return this.rowTargets.find((row) => row.contains(event.currentTarget))
  }

  // Dispatches a bubbling change so the unsaved-changes guard notices the edit.
  setDestroy(row, value) {
    const input = row.querySelector("input[name$='[_destroy]']")
    input.value = value
    input.dispatchEvent(new Event("change", { bubbles: true }))
  }
}
